// Community logo registry
// Maps community names to locally bundled logo assets

import npaLogo from '../assets/communities/npa_logo.svg';
import ruLogo from '../assets/communities/ru_logo.svg';

/**
 * Registry of community logos bundled with the application.
 * Add new community logos here to make them available without external uploads.
 */
const communityLogoRegistry: Record<string, string> = {
  // NPA Worldwide
  'NPA': npaLogo,
  'NPA Worldwide': npaLogo,

  // Recruitment United
  'RU': ruLogo,
  'Recruitment United': ruLogo,
};

/**
 * Get a community logo from the bundled assets.
 * Returns the local asset if available, otherwise returns the provided logoUrl.
 *
 * @param communityName - The name of the community
 * @param logoUrl - Fallback URL if no local asset exists
 * @returns The logo source (local asset or external URL)
 */
export function getCommunityLogo(communityName: string, logoUrl?: string): string | undefined {
  // First, try to find a local asset by exact match
  if (communityLogoRegistry[communityName]) {
    return communityLogoRegistry[communityName];
  }

  // Try case-insensitive match
  const normalizedName = communityName.toLowerCase();
  const matchedKey = Object.keys(communityLogoRegistry).find(
    key => key.toLowerCase() === normalizedName
  );

  if (matchedKey) {
    return communityLogoRegistry[matchedKey];
  }

  // Fallback to the provided logoUrl
  return logoUrl;
}

/**
 * Add a new community logo to the registry at runtime.
 * Useful for dynamic communities that aren't pre-bundled.
 *
 * @param communityName - The name of the community
 * @param logoSrc - The logo source (imported asset or URL)
 */
export function registerCommunityLogo(communityName: string, logoSrc: string): void {
  communityLogoRegistry[communityName] = logoSrc;
}
